export default [
    {
        path: 'atendimento-enfermagem',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-atendimento-enfermagem' */
            '@/views/pronto-atendimento/atendimento-enfermagem/Index'
        ),
        redirect: 'atendimento-enfermagem/index',
        children: [
            {
                name: 'pronto-atendimento-atendimento-enfermagem-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-atendimento-enfermagem' */
                    '@/views/pronto-atendimento/atendimento-enfermagem/List.vue'),
            },
            {
                name: 'pronto-atendimento-atendimento-enfermagem-create',
                path: 'create/:id/:plantaoId',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-atendimento-enfermagem' */
                    '@/views/pronto-atendimento/atendimento-enfermagem/Form'
                ),
            },
        ]
    }
]